module.exports = __webpack_public_path__ + "img/zb5.aa170874.png";